import { isArray, isNumber, isObject, isString } from '../utils/typeUtils';

export type ApiKeyTemplate = {
  id?: number;
  name: string;
  template: string;
  clawlers?: {
    id: number;
    name: string;
    imageName: string;
    apiKeyTemplateId: number;
  }[];
};

/**
 * APIキーテンプレート 型ガード
 */
export const isApiKeyTemplate = (arg: unknown): arg is ApiKeyTemplate => {
  const a = arg as ApiKeyTemplate;

  return isObject(a) && isNumber(a.id) && isString(a.name);
};

export const isApiKeyTemplates = (arg: unknown): arg is ApiKeyTemplate[] =>
  isArray(arg, isApiKeyTemplate);
